const breadcrumbs = {
  accessLevels: 'Access levels',
  controllers: 'Controllers',
  credentials: 'Credentials',
  dealerInfo: 'Dealer info',
  dealerView: 'Dealer view',
  doors: 'Doors',
  employees: 'Employees',
  events: 'Events',
  firmwareManager: 'Firmware manager',
  floorPlans: 'Floor plans',
  globalSettings: 'Global settings',
  hardware: 'Hardware',
  holidays: 'Holidays',
  inputs: 'Inputs',
  interlocks: 'Interlocks',
  lockdown: 'Lockdown',
  outputs: 'Outputs',
  schedules: 'Schedules',
  settings: 'Settings',
  sites: 'Sites',
  users: 'Users',

  activate: 'Activate',
  create: 'Create',
  edit: 'Edit',
  manage: 'Manage',
};

export default breadcrumbs;
